module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ni-divider', 'el-divider', ("el-divider--" + _vm.direction)]
  }, [(_vm.direction !== 'vertical') ? _c('div', {
    class: ['el-divider__text', ("is-" + _vm.contentPosition)]
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-ea4508d8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ni-ui/divider/divider.vue
// module id = gI8c
// module chunks = 81